import React from 'react';

/**
 * 고급 기능 섹션 컴포넌트
 */
function AdvancedSection() {
  return (
    <section id="advanced" className="guide-section">
      <h2>🎯 고급 기능</h2>
      
      <div className="feature-grid">
        <div className="feature-card">
          <h3>📤 데이터 내보내기</h3>
          <div className="feature-steps">
            <p><strong>내보내기 과정:</strong></p>
            <ol>
              <li>⚙️ 설정 메뉴 열기</li>
              <li>📊 "데이터 관리" 섹션</li>
              <li>📤 "내보내기" 버튼 클릭</li>
              <li>💾 JSON 파일로 다운로드</li>
            </ol>
            
            <div className="tip-box">
              <strong>💡 백업:</strong> 정기적인 데이터 백업으로 데이터 손실을 방지하세요.
            </div>
          </div>
        </div>

        <div className="feature-card">
          <h3>📤 안전한 공유</h3>
          <div className="feature-steps">
            <p><strong>공유 기능:</strong></p>
            <ol>
              <li>📤 패스워드 카드에서 공유 버튼 클릭</li>
              <li>🔐 암호화된 임시 링크 생성</li>
              <li>⏰ 만료 시간 설정 (1시간~7일)</li>
              <li>🔗 링크 복사 후 안전하게 전달</li>
            </ol>
            
            <div className="warning-box">
              <strong>⚠️ 주의:</strong> 공유 링크는 만료 시간 후 자동으로 삭제됩니다.
            </div>
          </div>
        </div>

        <div className="feature-card">
          <h3>🔐 2단계 인증 (2FA)</h3>
          <div className="feature-steps">
            <p><strong>설정 방법:</strong></p>
            <ol>
              <li>🛡️ 보안 기능에서 2FA 설정</li>
              <li>📱 QR 코드 스캔 또는 수동 키 입력</li>
              <li>🔢 인증 앱에서 생성된 코드 입력</li>
              <li>💾 백업 코드 8개 안전하게 보관</li>
            </ol>
            
            <p><strong>지원 앱:</strong></p>
            <ul>
              <li>📱 Google Authenticator</li>
              <li>🔐 Authy</li>
              <li>📲 Microsoft Authenticator</li>
            </ul>
          </div>
        </div>

        <div className="feature-card">
          <h3>📊 패스워드 히스토리</h3>
          <div className="feature-steps">
            <p><strong>히스토리 기능:</strong></p>
            <ul>
              <li>🕐 패스워드 변경 이력 추적</li>
              <li>🔄 이전 패스워드 재사용 방지</li>
              <li>📈 변경 주기 분석</li>
              <li>💡 변경 권장사항 제공</li>
            </ul>
            
            <p><strong>확인 방법:</strong></p>
            <ol>
              <li>패스워드 카드에서 📊 히스토리 버튼</li>
              <li>최근 5개 변경 이력 확인</li>
              <li>패스워드 강도 변화 추이 분석</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AdvancedSection;